import React from "react";
import { Link } from "~/patches/components";
import styles from "./ButtonRedBorder.module.scss";

const ButtonRedBorder = ({ field }) => (
	<Link className={styles.ButtonRedBorder} field={field} />
);

export default ButtonRedBorder;
